export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            爆料投稿
          </h2>
          <p className="mt-2 text-sm text-foreground-500">有猛料？欢迎向我们投稿，线索一经采用即获首页展示</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 border border-background-200/60 rounded-lg p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-8 text-center">
              <div className="p-4">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-100 text-primary-500">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <h4 className="text-sm font-bold text-foreground-900 mb-1">邮件投稿</h4>
                <p className="text-xs text-foreground-500">tips@51cg.cn</p>
              </div>
              <div className="p-4">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-full bg-accent-100 text-accent-500">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <h4 className="text-sm font-bold text-foreground-900 mb-1">微信投稿</h4>
                <p className="text-xs text-foreground-500">搜索：51吃瓜黑料</p>
              </div>
              <div className="p-4">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-full bg-secondary-100 text-secondary-500">
                  <i className="ri-shield-user-line text-lg"></i>
                </div>
                <h4 className="text-sm font-bold text-foreground-900 mb-1">匿名爆料</h4>
                <p className="text-xs text-foreground-500">严格保护隐私</p>
              </div>
            </div>

            <p className="text-center text-sm text-foreground-400">
              投稿即代表您同意本站内容发布规则。所有投稿均经过人工审核，违规内容将不予通过。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}